import axios from 'axios'
import { constructTimestampKey } from '../store.waste'

export default {
  populateStoreWithSynonyms: async ({ commit, dispatch }, key = 'localSynonymsResponse') => {
    const localDataIsPresent = await dispatch('localDataIsPresent', { key })
    const localDataIsStale = await dispatch('localDataIsStale', { key })

    if (localDataIsPresent && !localDataIsStale) {
      commit('SET_SYNONYMS', JSON.parse(localStorage.getItem(key)))
    } else {
      dispatch('getSynonymData', { key })
    }
  },
  localDataIsPresent({ dispatch }, payload) {
    const timestampKey = constructTimestampKey(payload.key)
    if (!!localStorage.getItem(payload.key) || !!localStorage.getItem(timestampKey)) return true

    return false
  },
  localDataIsStale({ dispatch }, { key, shelfLifeInHours = 24 }) {
    const timestampKey = constructTimestampKey(key)
    const localDate = new Date(localStorage.getItem(timestampKey))
    const localDataMaxDate = new Date(localDate).setHours(localDate.getHours() + shelfLifeInHours)

    return new Date() > new Date(localDataMaxDate)
  },
  storeDataInLocalStorage({ dispatch }, { key, value, timestamp = new Date() }) {
    const timestampKey = constructTimestampKey(key)
    localStorage.setItem(key, JSON.stringify(value))
    localStorage.setItem(timestampKey, timestamp.toString())
  },
  getSynonymData({ commit, dispatch }, { key, apiUrl = '/api/wastewizard.php?part=synonyms' }) {
    const throwError = () => {
      // eslint-disable-next-line
      dispatch(
        'errors/setErrorObject',
        { message: 'Er ging iets fout bij het ophalen van de synoniemen. Probeer het a.u.b. opnieuw.' },
        { root: true }
      )
    }

    return axios
      .get(apiUrl)
      .then(({ data: { data, error } }) => {
        if (data) {
          commit('SET_SYNONYMS', data)
          dispatch('storeDataInLocalStorage', {
            key: key,
            value: data
          })
        } else {
          throwError()

          if (error) {
            throw new Error(error)
          }
        }
      })
      .catch(e => {
        throwError()
        throw new Error(e.message)
      })
  },
  getWasteTypeData({ commit }, { municipalityId, id, apiUrl = '/api/wastewizard.php?part=wasteTypeData&garbageTypeId=', title }) {
    const throwError = () => {
      // eslint-disable-next-line
      dispatch('errors/setErrorObject', { message: 'Er ging iets fout bij het ophalen van afvaltype. Probeer het a.u.b. opnieuw.' }, { root: true })
    }

    commit('SET_ACTIVE_SYNONYM', title)
    apiUrl += id
    if (municipalityId) {
      apiUrl += '&municipality=' + municipalityId
    }
    axios
      .get(apiUrl)
      .then(({ data: { data, error } }) => {
        if (data) {
          commit('SET_ACTIVE_WASTETYPE', data[0])
          if (data[0] && data[0].stream && data[0].stream.id) {
            commit('SET_ACTIVE_WASTE_STREAM_ID', data[0].stream.id)
            commit('SET_IS_WASTE_STREAM', false)
          } else {
            commit('SET_ACTIVE_WASTE_STREAM_ID', id)
            commit('SET_IS_WASTE_STREAM', true)
          }
        } else {
          throwError()

          if (error) {
            throw new Error(error)
          }
        }
      })
      .catch(e => {
        throwError()
        throw new Error(e.message)
      })
  },
  loadWasteStreams({ commit, dispatch }, municipalityId) {
    const throwError = () => {
      // eslint-disable-next-line
      dispatch(
        'errors/setErrorObject',
        { message: 'Er ging iets fout bij het ophalen van de afvalstromen. Probeer het a.u.b. opnieuw.' },
        { root: true }
      )
    }

    return axios
      .get('/api/wastewizard.php?part=streams&municipality=' + municipalityId)
      .then(({ data: { data, error } }) => {
        if (data) {
          if (data) {
            commit('SET_WASTE_STREAMS', data)
          }
        } else {
          throwError()

          if (error) {
            throw new Error(error)
          }
        }
      })
      .catch(e => {
        throwError()
        throw new Error(e.message)
      })
  },
  setActiveWasteStreamId({ commit }, id) {
    commit('SET_ACTIVE_WASTE_STREAM_ID', id)
    setTimeout(() => {
      const accordionItems = document.querySelectorAll('.el-collapse-item')

      accordionItems.forEach(accordionItem => {
        accordionItem.addEventListener('click', () => {
          /* NOTE: Wait for accordion animation to finish */
          setTimeout(() => {
            const itemLocationData = accordionItem.getBoundingClientRect()

            if (itemLocationData.top + accordionItem.offsetHeight > window.innerHeight) {
              accordionItem.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 250)
        })
      })
    }, 100)
  },
  clearActiveSynonymAndWasteStreamId({ commit }) {
    commit('SET_ACTIVE_SYNONYM', null)
    commit('SET_ACTIVE_WASTE_STREAM_ID', null)
  },
  clearActiveSynonym({ commit }) {
    commit('SET_ACTIVE_SYNONYM', null)
  },
  clearActiveWasteType({ commit }) {
    commit('SET_ACTIVE_WASTETYPE', null)
  },
  setShowResults({ commit }, payload) {
    commit('SET_SHOW_RESULTS', payload)
  }
}
